
export function convertEpochDate(epoch: any): string {
    const date = new Date(+epoch);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function dateStringToEpoch(dateString: string) {
    // Split the date string into year, month, and day components
    const [year, month, day] = dateString.split('-').map(Number);
    
    // Create a new Date object
    // Note: Months in JavaScript are 0-indexed, so we subtract 1 from the month component
    const dateObject = new Date(year, month - 1, day, 13, 0, 0, 0);
    
    // Get the epoch timestamp (in milliseconds)
    const epochTimestamp = dateObject.getTime();
    
    return epochTimestamp;
}

export function isPastDate(dateString: string) {
    // Split the date string into year, month, and day components
    const [year, month, day] = dateString.split('-').map(Number);
    
    // Create a new Date object
    // Note: Months in JavaScript are 0-indexed, so we subtract 1 from the month component
    const selectedDate = new Date(year, month - 1, day);
    
    // Get the current date
    const currentDate = new Date();
    
    // Compare the selected date with the current date
    return selectedDate.getTime() < currentDate.getTime();
}